import { HeadProps } from "gatsby"
import React from "react"

import DatoSeo from "../../dato-components/dato-seo"
import { ArticleJsonMd } from "../../dato-components/dato-seo/article-json-md"
import CaseStudyContent from "../../page-components/case-studies/case-study-content"
import { CaseStudyPageContext } from "../../page-components/case-studies/types"
import Layout from "../../shared-components/layout"

type Props = {
  pageContext: CaseStudyPageContext
}

const CaseStudyArticleTemplate = ({ pageContext: { ...props } }: Props) => (
  <Layout includeScrollProgress>
    <CaseStudyContent {...props} />
  </Layout>
)

export default CaseStudyArticleTemplate

export const Head = ({
  pageContext: {
    seoMetaTags,
    thumbnail: { url },
    title,
    publicationDate,
    authorName,
  },
  location: { pathname },
}: HeadProps<object, CaseStudyPageContext>) => (
  <>
    <DatoSeo seoMetaTags={seoMetaTags} pathname={pathname} />
    <ArticleJsonMd
      headline={title}
      image={url}
      datePublished={publicationDate}
      dateModified={publicationDate}
      authorNames={[authorName]}
    />
  </>
)
